
export enum USER_ROLE {
    CFF_MEDISPEND_ADMIN = "ROLE_CFF_MediSpend_admin",
    CFF_CLIENT_ADMIN = "ROLE_CFF_admin_admin"
}

export const ACCESS_DENIED = "You have no permission to view Custom Form Fields application. Please contact your administrator.";
